var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBusinessInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 178 162",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_business_info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.185393, -0.436764)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.15,
    fill: "#4DB6AC",
    cx: 84,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.883457, 30.121920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.25,19.5 L71.5,19.5 L71.5,4.875 C71.5,2.18161011 69.3183899,0 66.625,0 L37.375,0 C34.6816101,0 32.5,2.18161011 32.5,4.875 L32.5,19.5 L9.75,19.5 C4.36520386,19.5 0,23.8652039 0,29.25 L0,81.25 C0,86.6347961 4.36520386,91 9.75,91 L94.25,91 C99.6347961,91 104,86.6347961 104,81.25 L104,29.25 C104,23.8652039 99.6347961,19.5 94.25,19.5 Z",
    id: "Path",
    fill: "#F8F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.25,19.5 L71.5,19.5 L71.5,4.875 C71.5,2.18161011 69.3183899,0 66.625,0 L37.375,0 C34.6816101,0 32.5,2.18161011 32.5,4.875 L32.5,19.5 L9.75,19.5 C4.36520386,19.5 0,23.8652039 0,29.25 L0,81.25 C0,86.6347961 4.36520386,91 9.75,91 L94.25,91 C99.6347961,91 104,86.6347961 104,81.25 L104,29.25 C104,23.8652039 99.6347961,19.5 94.25,19.5 Z M39,6.5 L65,6.5 L65,19.5 L39,19.5 L39,6.5 Z M97.5,81.25 C97.5,83.041626 96.041626,84.5 94.25,84.5 L9.75,84.5 C7.95837402,84.5 6.5,83.041626 6.5,81.25 L6.5,52 L39,52 L39,60.125 C39,62.8164062 41.1835938,65 43.875,65 L60.125,65 C62.8164063,65 65,62.8164062 65,60.125 L65,52 L97.5,52 L97.5,81.25 Z M45.5,58.5 L45.5,52 L58.5,52 L58.5,58.5 L45.5,58.5 Z M97.5,45.5 L6.5,45.5 L6.5,29.25 C6.5,27.458374 7.95837402,26 9.75,26 L94.25,26 C96.041626,26 97.5,27.458374 97.5,29.25 L97.5,45.5 Z",
    id: "Shape",
    fill: "#565D6A",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.15,
    fill: "#707784",
    cx: 33.1830986,
    cy: 32.7464789,
    r: 29.2535211
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 29.2535211,
    cy: 29.2535211,
    r: 29.2535211
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2535211,5.68434189e-13 C13.0933099,5.68434189e-13 0,13.0933099 0,29.2535211 C0,45.4137324 13.0933099,58.5070423 29.2535211,58.5070423 C45.4137324,58.5070423 58.5070423,45.4137324 58.5070423,29.2535211 C58.5070423,13.0933099 45.4137324,5.68434189e-13 29.2535211,5.68434189e-13 Z M29.2535211,11.3239437 C34.9862215,11.3239437 39.6338028,15.971525 39.6338028,21.7042254 C39.6338028,27.4369258 34.9862215,32.084507 29.2535211,32.084507 C23.5208207,32.084507 18.8732394,27.4369258 18.8732394,21.7042254 C18.8732394,15.971525 23.5208207,11.3239437 29.2535211,11.3239437 Z M29.2535211,51.9014085 C22.3293784,51.9014085 16.124847,48.7637785 11.9727113,43.8566671 C14.1902939,39.681032 18.5311159,36.8028169 23.5915493,36.8028169 C23.874694,36.8028169 24.1577234,36.8500461 24.4290032,36.9325243 C25.9624539,37.4279699 27.5667484,37.7464789 29.2535211,37.7464789 C30.9402939,37.7464789 32.556338,37.4279699 34.078039,36.9325243 C34.3493188,36.8500461 34.6323483,36.8028169 34.915493,36.8028169 C39.9759264,36.8028169 44.3167484,39.681032 46.534331,43.8566671 C42.3821953,48.7637785 36.1776639,51.9014085 29.2535211,51.9014085 Z",
    id: "Shape",
    fill: "#A41B32",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.479167,10.9375 L167.0625,10.9375 L167.0625,0.520833333 C167.0625,0.233078003 166.829422,0 166.541667,0 L165.458333,0 C165.170578,0 164.9375,0.233078003 164.9375,0.520833333 L164.9375,10.9375 L154.520833,10.9375 C154.233078,10.9375 154,11.170578 154,11.4583333 L154,12.5416667 C154,12.829422 154.233078,13.0625 154.520833,13.0625 L164.9375,13.0625 L164.9375,23.4791667 C164.9375,23.766922 165.170578,24 165.458333,24 L166.541667,24 C166.829422,24 167.0625,23.766922 167.0625,23.4791667 L167.0625,13.0625 L177.479167,13.0625 C177.766922,13.0625 178,12.829422 178,12.5416667 L178,11.4583333 C178,11.170578 177.766922,10.9375 177.479167,10.9375 Z",
    fill: "#D1D3D4",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessInfo);
export default __webpack_public_path__ + "static/media/icon_business_info.4e34287e635353f1a02acc6b3430ef44.svg";
export { ForwardRef as ReactComponent };